var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OrderGantt',[_c('Header',{ref:"header",attrs:{"slot":"header"},slot:"header"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }